import MarketplaceService from '../services/MarketplacesService';
import MarketplaceModel from '../models/MarketplaceModel';

export default {
  data() {
    return {
      model: MarketplaceModel.getDefaults(),
      loading: false,
    };
  },
  methods: {
    $marketplace_save() {
      this.loading = true;
      const data = MarketplaceModel.toApiRequest(this.model);
      return new Promise((resolve, reject) => {
        MarketplaceService.update(this.model.id, data).then(() => {
          this.loading = false;
          this.$toastr.success(this.$t('Action', { object: this.$tc('Marketplaces', 1), action: this.$t('updated') }), this.$t('Success'));
          resolve();
        }).catch(error => {
          if (error.message.length > 0) {
            this.$notifications_error(error.message);
          } else {
            this.$errors_showNetworkErrorMessage();
          }
          this.loading = false;
          reject(error);
        });
      });
    },
    $marketplace_load(marketplaceId) {
      this.loading = true;
      MarketplaceService.findById(marketplaceId).then(response => {
        this.loading = false;
        this.model = MarketplaceModel.fromApiResponse(response);
      }).catch(() => {
        this.loading = false;
        this.$errors_showNetworkErrorMessage();
      });
    },
    $marketplace_getRouteId() {
      return parseInt(this.$route.params.marketplaceId, 10);
    },
  },
  computed: {
    $marketplace_id() {
      return this.$marketplace_getRouteId();
    },
  },
};
